import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@/store/auth.store';
import { UserStore } from '@/store/user.store';

/**
 * Guard: гарантирует загрузку user до roleGuard.
 * Вся логика загрузки — в UserStore.loadCurrentUser().
 */
export const ensureUserLoadedGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!authStore.isAuthenticated()) return true;

  try {
    await userStore.loadCurrentUser();
    return true;
  } catch {
    return router.createUrlTree(['/login']);
  }
};
